// Mobile Menu
var $ = jQuery.noConflict(true);

$(".mobile_nav").click(function() {
	$('ul.menu').fadeToggle();
	$('ul.menu').toggleClass('mobile');
});

$(".search_icon").click(function() {
	$('.search_form').fadeToggle();
});

$(".mobile_nav").click(function() {
	var width = $(this).width(); // The window width
	if (width < 768) {
		$("li:has(ul)").click(function(){
			$("ul",this).slideToggle();
		});
	}
});

var $grid = $('.grid').isotope({
	itemSelector: '.grid-item',
	layoutMode: 'masonry',
	percentPosition: true,
	masonry: {
		columnWidth: '.one-third',
		gutter: '.gutter-sizer'
	}
});

$grid.imagesLoaded().progress( function() {
	$grid.isotope('layout');
});

// filter items on button click
$('.filter-button-group').on( 'click', 'button', function() {
	var filterValue = $(this).attr('data-filter');
	$grid.isotope({
		filter: filterValue
	});
});

// change is-checked class on buttons
$('.button-group').each( function( i, buttonGroup ) {
	var $buttonGroup = $( buttonGroup );
	$buttonGroup.on( 'click', 'button', function() {
		$buttonGroup.find('.active').removeClass('active');
		$( this ).addClass('active');
		$('.no_results').hide(0);
		$('.no_results').delay(500).fadeIn(200);
	});
});

$(window).load(function(){
	$('.flexslider').flexslider({
		animation: "fade",
		directionNav: "true",
		controlNav: "false",
		start: function(slider){
			$('body').removeClass('loading');
		}
	});

	if( $('.flexslider-carousel li').length > 4 ){
		$('.flexslider-carousel').flexslider({
			animation: "slide",
			animationLoop: true,
			itemWidth: 200,
			itemMargin: 20,
			directionNav: "true",
			controlNav: "false",
		});
	}
});

/*$container.append(divs).isotope('appended', divs, function () {
	$container.isotope('reLayout');
});*/

$.fn.doubleTapToGo = function( params )
{
	if( !( 'ontouchstart' in window ) &&
		!navigator.msMaxTouchPoints &&
		!navigator.userAgent.toLowerCase().match( /windows phone os 7/i ) ) return false;

	this.each( function()
	{
		var curItem = false;

		$( this ).on( 'click', function( e )
		{
			var item = $( this );
			if( item[ 0 ] != curItem[ 0 ] )
			{
				e.preventDefault();
				curItem = item;
			}
		});

		$( document ).on( 'click touchstart MSPointerDown', function( e )
		{
			var resetItem = true,
				parents	  = $( e.target ).parents();

			for( var i = 0; i < parents.length; i++ )
				if( parents[ i ] == curItem[ 0 ] )
					resetItem = false;

			if( resetItem )
				curItem = false;
		});
	});
	return this;
};
